var data = {
  show: true,
  map: 'Map', //使用
  roam: true,
  zoom: 1.0,
  // center: [90, 35],
  itemStyle: {
    normal: {
      borderColor: '#00F6FF',
      borderWidth: 1,
      shadowColor: 'rgba(10,76,139,1)',
      shadowOffsetY: 0,
      shadowBlur: 60,
      areaColor: {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0,
          color: '#073684' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#061E3D' // 100% 处的颜色
        }],
      },
    },
    emphasis: {
      show: true,
      color: "#0F1C3C"
    },
  },

  label: {
    normal: {
      show: true,
      color: "rgba(249, 249, 249,0.5)", //省份标签字体颜色
      formatter: p => {
        switch (p.name) {
          case "内蒙古自治区":
            p.name = "内蒙古";
            break;
          case "西藏自治区":
            p.name = "西藏";
            break;
          case "新疆维吾尔自治区":
            p.name = "新疆";
            break;
          case "宁夏回族自治区":
            p.name = "宁夏";
            break;
          case "广西壮族自治区":
            p.name = "广西";
            break;
          case "香港特别行政区":
            p.name = "香港";
            break;
          case "澳门特别行政区":
            p.name = "澳门";
            break;
          default:
            break;
        }
        return p.name;
      }
    },
    emphasis: {
      show: true,
      color: "#FFF"
    },

  }
}

export default {
  geo(isChina){
    var option = JSON.parse(JSON.stringify(data))
    if(isChina){
      option.zoom = 1.4
      option.center = [95, 35]
    }
    return option
  }
}



// WEBPACK FOOTER //
// ./src/views/home/board/options/geo.js